import { t } from "@lingui/macro";

import { InfoRestrictionBar } from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/InfoRestrictionBar/InfoRestrictionBar";
import { dateUtils, restrictionUtils } from "@whoosh/utilities";

import { CustomColor } from "../__generated__/TimeSlotListInternalQuery.graphql";

export type RestrictionInfoBarProps = {
  id: string;
  name: string;
  displayName: string | null;
  startAt: string | null;
  displayStartAt?: string | null;
  endAt: string | null;
  allDay: boolean;
  visibilityColor?: CustomColor | null;
  courseMessage?: string | null;
  memberMessage?: string | null;
};

export const RestrictionInfoBar = ({
  name,
  startAt,
  displayStartAt,
  endAt,
  allDay,
  courseMessage,
  visibilityColor,
  displayName,
  memberMessage,
}: RestrictionInfoBarProps) => {
  const { endAt: restrictionEndAt } =
    restrictionUtils.getTimeOperatorAndStartEndAt(startAt, endAt);

  const formatStartTime = displayStartAt
    ? dateUtils.formatHHMM(displayStartAt)
    : "";
  const formatEndTime = restrictionEndAt
    ? dateUtils.formatHHMM(restrictionEndAt)
    : "";

  return (
    <InfoRestrictionBar
      title={displayName || name}
      color={`surface-user-selectable-color${visibilityColor ?? "A"}-subtlest`}
      courseNames={courseMessage ?? t`All Courses`}
      allDay={allDay}
      startAt={displayStartAt ? formatStartTime ?? "" : t`Start`}
      endAt={formatEndTime ?? ""}
      memberMessage={memberMessage}
    />
  );
};
